export default __webpack_public_path__ + "f9476b69ff64ab5157a65e17911e04b4.wasm";